import { render, staticRenderFns } from "./submissionRequests.vue?vue&type=template&id=0c4b01d4&"
import script from "./submissionRequests.vue?vue&type=script&lang=js&"
export * from "./submissionRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports